var React = require('react');

function BackInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.3136 16L4.68617 16M10.2499 21.75L4.49988 16L10.2499 10.3432","stroke":"black","strokeOpacity":"0.85","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BackInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = BackInline;

BackInline.default = BackInline;
